<template>
  <rect opacity="0.1" width="40" height="40" rx="4" fill="#3769D6" />
  <path
    d="M12 12C12 10.8954 12.8954 10 14 10H26C27.1046 10 28 10.8954 28 12V28C28 29.1046 27.1046 30 26 30H14C12.8954 30 12 29.1046 12 28V12Z"
    fill="#2E63D6"
  />
  <rect x="17" y="14" width="6" height="2" rx="1" fill="white" />
  <rect x="15" y="18" width="10" height="2" rx="1" fill="#92AFEA" />
  <rect x="15" y="22" width="10" height="2" rx="1" fill="#92AFEA" />
</template>
